import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AttachmentDto } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { MimetypeService } from '../../services/mimetype.service';

@Component({
  selector: 'app-equaltec-modal-presavisione',
  templateUrl: './equaltec-modal-presavisione.component.html',
  styleUrls: ['./equaltec-modal-presavisione.component.css']
})
export class EqualtecModalPresavisioneComponent {

  @Input() idDocument: string;
  @Input() fileName: string;
  @Input() idAllegato: string;
  @Input() download: boolean;

  constructor(
    @Optional() private readonly activeModal: NgbActiveModal,
    public translate: TranslateService,
    private commonService: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService) {
  }

  public confirm(): void {
    this.acceptDisclaimer(true);
  }

  public dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  private acceptDisclaimer(presaVisione: boolean): void {
    const url = 'api/rest/acceptDisclaimer';
    const params = {
      params: {
        idDocument: this.idDocument,
        idAllegato: this.idAllegato,
        fileName: this.fileName,
        download: this.download,
        presaVisione: presaVisione
      }
    };

    this.commonService.getData(url, params, false).subscribe(result => {
      if (!this.activeModal) {
        return;
      }

      if (presaVisione) {
        const attachment = result as AttachmentDto;

        if (this.hasAttachmentData(attachment)) {
          this.openAttachment(attachment);
        } else {
          alert("Impossibile recuperare l'allegato!");
        }

        this.activeModal.close();
      } else {
        this.activeModal.dismiss();
      }
    }, error => {
      console.error('error on acceptDisclaimer', error);
      this.activeModal.dismiss();
    });
  }

  private openAttachment(attachment: AttachmentDto): void {
    const fileName = attachment.nomeFile;
    const ext = fileName.split('.').pop() || '';
    const downloadLink = document.createElement("a");

    this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
      .then(blob => {
        const url = URL.createObjectURL(blob);

        if (this.download) {
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
          window.open(url, '_blank');
        }
      });
  }

  private dataURIToBlob(dataURI: any, mimeString: string): Promise<Blob> {
    return new Promise(resolve => {
      const binStr = atob(dataURI);
      const len = binStr.length;
      const arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      resolve(new Blob([arr], { type: mimeString }));
    });
  }

  private hasAttachmentData(attachment: AttachmentDto): boolean {
    return attachment != null && attachment.data != null;
  }
}
